export default function () {
  if (
    Array.from(
      document.querySelectorAll(
        '.PageMain--pet-guide-center .PetGuideCenter__container'
      )
    ).length > 0
  ) {
    import(
      /* webpackChunkName: "pet-guide-center-module" */ './pet-guide-center'
    ).then((module) => {
      const PetGuideCenter = module.default

      /**
       * Itchy Pet Center
       */
      if (document.querySelector('.PageMain--itchy-pet-center')) {
        const listContent = {
          overview: 'itchy-pet-center-content-overview-',
          signs: 'itchy-pet-center-content-signs-',
          treatment: 'itchy-pet-center-content-treatment-',
          prevention: 'itchy-pet-center-content-prevention-',
        }

        PetGuideCenter(listContent)
      }

      /**
       * Diabetes Hub
       */
      if (document.querySelector('.PageMain--diabetes-hub')) {
        const listContent = {
          overview: 'diabetes-hub-content-overview-',
          signs: 'diabetes-hub-content-signs-',
          diagnosis: 'diabetes-hub-content-diagnosis-',
          management: 'diabetes-hub-content-management-',
        }

        PetGuideCenter(listContent)

        // Change the title on the Hero Banner - TABS
        const tabs = Array.from(
          document.querySelectorAll(
            '.PageMain--pet-guide-center .PetGuideCenter__tab-item'
          )
        )
        const titles = Array.from(
          document.querySelectorAll(
            '.PageMain--pet-guide-center .PetGuideCenter__hero-banner-title'
          )
        )

        if (tabs.length > 0 && titles.length > 0) {
          tabs.forEach((tab) => {
            tab.addEventListener('click', function () {
              const anchor = tab.dataset?.tab || ''

              titles.forEach((title) => {
                if (
                  (anchor.includes('dog') && title.className.includes('dog')) ||
                  (anchor.includes('cat') && title.className.includes('cat'))
                ) {
                  title.classList.add('active')
                } else {
                  title.classList.remove('active')
                }
              })
            })
          })
        }

        // Actions to execute because of the URL param "tab"
        const urlParams = new URLSearchParams(window.location.search)
        const paramTab = urlParams.get('tab')

        if (paramTab) {
          titles.forEach((title) => {
            if (
              (paramTab.includes('dog') && title.className.includes('dog')) ||
              (paramTab.includes('cat') && title.className.includes('cat'))
            ) {
              title.classList.add('active')
            } else {
              title.classList.remove('active')
            }
          })
        }
      }
    })
  }
}
